export const STATEMENT_TYPE = {
  ADJUST: "adjust",
  REPLACE: "replace",
};

export const STATEMENT_TYPE_LABEL = {
  [STATEMENT_TYPE.ADJUST]: "Điều chỉnh",
  [STATEMENT_TYPE.REPLACE]: "Thay thế",
};

// Số dòng mỗi trang khi gọi statements/prepare (phân trang phía server)
export const PREPARE_PER_PAGE = 50;

// Danh sách bảng kê ít dòng hơn nhiều nên để mặc định nhỏ
export const STATEMENT_LIST_PER_PAGE = 10;

export const EMPTY_PREPARE_RESULT = {
  valid: {
    items: [],
    total: 0,
    page: 1,
    perPage: PREPARE_PER_PAGE,
    pageCount: 0,
    sum_net: 0,
    sum_vat: 0,
    sum_pay: 0,
  },
  invalid: {
    items: [],
    total: 0,
    page: 1,
    perPage: PREPARE_PER_PAGE,
    pageCount: 0,
  },
};

// Tháng hiển thị tiếng Việt, giá trị là số tháng 2 chữ số dùng để ghép YYYY-MM
export const MONTH_OPTIONS = Array.from({ length: 12 }, (unused, index) => {
  const value = String(index + 1).padStart(2, "0");
  return { value, label: `Tháng ${value}` };
});

// Khoảng năm cho ô chọn kỳ hóa đơn: 5 năm trước tới 1 năm sau năm hiện tại
export const YEAR_RANGE_BEFORE = 5;
export const YEAR_RANGE_AFTER = 1;

export const STATEMENT_PDF_STATUS_GENERATED = "generated";

// Chỉ bảng kê còn nháp mới được sửa, lưu và ký
export const CQT_STATUS_DRAFT = "draft";

// Trạng thái gửi cơ quan thuế
export const CQT_STATUS_LABEL = {
  draft: "Nháp",
  approved: "CQT duyệt",
  waiting_buyer: "Chờ người mua ký",
  signing: "Đang ký",
  signed: "Đã ký",
  sent: "Đã gửi CQT",
  accepted: "CQT chấp nhận",
  rejected: "CQT từ chối",
};

// Trạng thái duyệt nội bộ. BE chưa trả approve_status cho bảng kê, tạm dùng
// đúng bộ mã M/P/A/R của luồng duyệt hóa đơn (constants/FormatDataContanst).
export const APPROVE_STATUS_LABEL = {
  M: "Lưu tạm",
  P: "Gửi chờ duyệt",
  A: "Đã duyệt",
  R: "Từ chối duyệt",
};

// Cờ thử nghiệm: bật thì mọi nút của luồng duyệt (Lưu, Lưu và gửi duyệt,
// Duyệt, và các nút mới ngoài danh sách) đều hiện, bỏ qua kiểm tra quyền lẫn
// trạng thái duyệt. PHẢI tắt trước khi lên production.
export const IS_TEST = false;

// Email giả để thử luồng gửi duyệt khi BE chưa trả email người mua.
// Chỉ dùng khi IS_TEST bật.
export const IS_TEST_BUYER_EMAILS = [
  "ketoan.nguoimua@example.com",
  "giamdoc.nguoimua@example.com",
];

// Mốc trong luồng duyệt: lưu tạm -> gửi chờ duyệt -> đã duyệt
export const APPROVE_STATUS_DRAFT = "M";
export const APPROVE_STATUS_SUBMITTED = "P";
export const APPROVE_STATUS_APPROVED = "A";
export const APPROVE_STATUS_REJECTED = "R";

export const APPROVE_STATUS_COLOR = {
  M: "secondary",
  P: "warning",
  A: "success",
  R: "danger",
};

export const CQT_STATUS_COLOR = {
  draft: "secondary",
  approved: "success",
  waiting_buyer: "warning",
  signing: "warning",
  signed: "info",
  sent: "info",
  accepted: "success",
  rejected: "danger",
};
